export default __webpack_public_path__ + "static/media/noBets.f1f23d00.mp3";